import { maxLengthInput } from './lib/constants';

// Sign In Page strings
export const signInTitle = 'Welcome back!';
export const signInSubtitle = 'Please enter your details.';
export const signInCTAQuestion = "Don't have an account?";
export const signInCTAText = 'Sign up';
export const forgotPasswordText = 'Forgot password';
export const signInButtonLabel = 'Sign in';
export const emailRequiredValidationMessage = 'Please enter an email address';
export const passwordRequiredValidationMessage = 'Please enter the password';

// Sign Up Page strings
export const signUpTitle = 'Sign up for ALX Africa';
export const signUpCTAQuestion = 'Already have an account?';
export const signUpCTAText = 'Log in';
export const signUpButtonLabel = 'Sign Up';
export const signUpWithGoogleLabel = 'Sign up with Google';
export const firstNameRequiredValidationMessage =
  'Please enter your First Name';
export const lastNameRequiredValidationMessage = 'Please enter your Last Name';
export const passwordRulesValidationMessage =
  'Password should contain at lease 1 number, 1 special character, 1 uppercase, 1 lowercase letter and have a length of minimum 8 characters';
export const confirmationCodeRequiredValidationMessage =
  'Please enter the reset password code';
export const confirmPasswordRequiredValidationMessage =
  'Please enter the new password';
export const nameValidationMessage =
  'Must not contain numbers, whitespaces or special characters';
export const maxLengthExceededValidationMessage = `Maximum characters count exceeded (${maxLengthInput} characters)`;

// Confirm Sign Up String
export const confirmSignUpTitle = 'Sign up confirmation';

// Forgot Password string

export const forgotPasswordTitle = "Can't log in?";
export const forgotPasswordSubtitle =
  'Type your email so we can send you a password recovery email';
export const forgotPasswordButtonLabel = 'Reset password';
export const forgotPasswordCTAQuestion = 'Go back to';
export const forgotPasswordCTAText = 'Log in';

// General form related strings
export const emailLabel = 'Email *';
export const emailPlaceholder = 'Enter your email';
export const passwordLabel = 'Password *';
export const passwordPlaceholder = 'Create a password';
export const passwordDescription =
  'Must be at least 8 characters, contain uppercase, lowercase, numeric and symbol characters';
export const newPasswordLabel = 'New password';
export const newPasswordPlaceholder = 'Enter the new password';
export const confirmationCodeLabel = 'Confirmation code';
export const confirmNewPasswordLabel = 'Confirm new password';
export const firstNameLabel = 'First Name *';
export const firstNamePlaceholder = 'Enter your first name';
export const lastNameLabel = 'Last Name *';
export const lastNamePlaceholder = 'Enter your last name';

// Error Messages
export const generalErrorText =
  'An error has occurred! Please try again later.';
export const networkErrorText =
  'A network error has occurred. Please try again later.';
export const passwordResetMismatch = "Passwords don't match";
